export default "__VITE_ASSET__Dl6wly7n__"